<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("concession") }}
      </div>
      <div>
        <router-link class="btn-blue" to="concession"
          >{{ $t("concession") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label :class="selectCinema.length > 0 ? 'shift-up' : ''"
              >Select Cinema</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  href="#"
                  name="selectcine"
                  id="selectcine"
                  @click="onSelect($event, cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="``" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selectCinema.length == 0">{{
                msgcinema
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="conssname"
                name="concession_name"
                id="concession_name"
                v-validate="'required'"
              />
              <label>{{ $t("concession") }}</label>
            </div>
            <!-- <Tooltip :title="``" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('concession_name')">{{
              errors.first("concession_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="consspos"
                name="concession_pos"
                id="concession_pos"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("noofpos") }}</label>
            </div>
            <!-- <Tooltip :title="``" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('concession_pos')">{{
              errors.first("concession_pos")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="consskiosk"
                name="concession_kiosk"
                id="concession_kiosk"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("kiosk") }}</label>
            </div>
            <!-- <Tooltip :title="``" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('concession_kiosk')">{{
              errors.first("concession_kiosk")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="consssignage"
                name="concession_signage"
                id="concession_signage"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("noofsignage") }}</label>
            </div>
            <!-- <Tooltip :title="``" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('concession_signage')">{{
              errors.first("concession_signage")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="consscounter"
                name="concession_counter"
                id="concession_counter"
                v-validate="'required|numeric'"
              />
              <label>{{ $t("fnbcounter") }}</label>
            </div>
            <!-- <Tooltip :title="``" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('concession_counter')">{{
              errors.first("concession_counter")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  value="Y"
                  name="check-button"
                  v-model="isActive"
                  unchecked-value="N"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="updateUser(true)"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="concession"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemaService from "@/services/CinemasService";

export default {
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      isRoleID: true,
      btenable: false,
      submitted: false,
      selectCinema: "",
      cl_id: "",
      cinemaid: "",
      msgcinema: "",
      conssname: "",
      consspos: "",
      consskiosk: "",
      consssignage: "",
      consscounter: "",
      isActive: false,
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    this.cl_id = id;
    // console.log("id :", id);
    this.getConcessionlist(id);
    let roleid = this.secureStore.get("USINFO").role_id;
    let obj = this.secureStore.get("USINFO").cinema_id;

    if (true) {
      this.isRoleID = false;
      this.getCinemasList(obj);
    } else {
      this.getCinemasList(obj);
    }
  },
  methods: {
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getConcessionlist(cl_id) {
      let payload = {
        limit: null,
        currentPage: null,
      };
      let cid = {
        cl_id: cl_id,
      };
      CinemaService.getConcessions(payload, cid)
        .then((response) => {
          // console.log("response :", response);
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Concessions = data.Records[0];
              this.setCinema(this.Concessions.cinema_id);
              this.conssname = this.Concessions.cl_name;
              this.consspos = this.Concessions.cld_no_of_pos;
              this.consskiosk = this.Concessions.cld_no_of_kiosk;
              this.consssignage = this.Concessions.cld_no_of_signages;
              this.consscounter = this.Concessions.cld_no_of_fnb_counters;
              this.isActive = this.Concessions.cld_is_active;

              console.log("this.Concessions :", this.Concessions);
            } else {
              this.$toasted.show(data.message);
            }
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemasList: function (cine_id) {
      console.log("object :", cine_id);
      this.Cinemas = [];
      // let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              // this.Cinemas.map(x => {
              // console.log("x :", x);
              if (String(cine_id) === String(x.cine_id)) {
                this.selectCinema = x.cine_name;
                this.cinemaid = x.cine_id;
                // console.log("this.selectCinema :", this.selectCinema);
              }
            });
          } else {
            // Show Errors
            this.$toasted.show(data.message);
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    setCinema: function (cine_id) {
      console.log("object :", cine_id);
      // let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.Cinemas = data.Records;
            data.Records.map((x) => {
              // console.log("x :", x);
              if (String(cine_id) === String(x.cine_id)) {
                this.selectCinema = x.cine_name;
                this.cinemaid = x.cine_id;
                // console.log("this.selectCinema :", this.selectCinema);
              }
            });
          } else {
            // Show Errors
            this.$toasted.show(data.message);
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelect(event, cinema) {
      console.log("cinema :", cinema);
      this.selectCinema = cinema.cine_name;
      this.cinemaid = cinema.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },

    updateUser(flag) {
      this.submitted = true;
      if (this.selectCinema.length == 0) {
        this.msgcinema = "Please Select Cinema.";
        return;
      } else {
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.btenable = true;
            let payload = {
              clid: this.cl_id,
              conss_name: this.conssname,
              conss_cinemaid: this.cinemaid,
              conss_pos: this.consspos,
              conss_kiosk: this.consskiosk,
              conss_signage: this.consssignage,
              conss_counter: this.consscounter,
              is_active: this.isActive,
            };
            payload.is_active == "" ? payload.is_active == "N" : "";
            console.log("payload :", payload);
            CinemaService.updateConcession(payload)
              .then((response) => {
                this.btenable = false;
                console.log("response :", response);

                const { data } = response;
                if (data.status) {
                  this.$router.push({
                    path: "/cinema-manager/concession",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ConcessionComponents/editConcession.vue